import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { createAuth, getAuth } from '../../features/auth/authSlice';
import { toast } from 'react-toastify';
import { useAuth } from '../../auth/AuthProvider';
import "./index.css";
import { useTranslation } from 'react-i18next';


const UserSignIn = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [activeForm, setActiveForm] = useState(true); //true=>login false=>signup
    const [registrationFormData, setRegistrationFormData] = useState({ first_name: "", last_name: "", email: "", password: "", role: "user" });
    const [logInFormData, setLogInFormData] = useState({ email: "user@yopmail.com", password: "Test@123" });
    const { login, fromCheckout } = useAuth();


    const { user, status, message } = useSelector(state => state.auth);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (activeForm) {
            setLogInFormData({
                ...logInFormData,
                [name]: value,
            });
        } else {
            setRegistrationFormData({
                ...registrationFormData,
                [name]: value,
            });
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (activeForm) {
            dispatch(getAuth(logInFormData));
        } else {
            dispatch(createAuth(registrationFormData));
        }
    }

    useEffect(() => {
        if (status) {
            login(user);
            if (fromCheckout) {
                navigate(`/checkout`);
            } else {
                navigate(`/`);
            }
            toast.success(message);
        }
        // // console.log("fromCheckout :: ", fromCheckout);
    }, [status, user, login, navigate, message, fromCheckout])

    return (
        <div className="sign_page">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="registration-wrapper-1 sign_card">
                            <h3 className="title animated fadeIn">
                                {activeForm ? t('auth.logInTitle') : t('auth.signUpTitle')}
                            </h3>
                            <form action="#" className={activeForm ? "registration-form form_style" : "d-none"}>
                                <div className="input-wrapper">
                                    <label htmlFor="email">{t('auth.email')}*</label>
                                    <input type="email" id="email" name='email' value={logInFormData?.email || ""} onChange={handleInputChange} className='form-control' />
                                </div>
                                <div className="input-wrapper">
                                    <label htmlFor="password">{t('auth.password')}*</label>
                                    <input type="password" id="password" name='password' value={logInFormData?.password || ""} onChange={handleInputChange} className='form-control' />
                                </div>
                                {/* <div className="input-wrapper row mt-3">
                                    <div className="col-sm-6">
                                        <div className="form-check form-switch-success">
                                            <input className="form-check-input" type="checkbox" id="customSwitchSuccess" />
                                            <label className="form-check-label" htmlFor="customSwitchSuccess">{t('auth.rememberMe')}</label>
                                        </div>
                                    </div>
                                    <div className="col-sm-6 text-end">
                                        <Link to="auth-recover-pw.html" className="forget-text">{t('auth.forgotPassword')}</Link>
                                    </div>
                                </div> */}
                                <button className=" btn-primary btn-titlecolor" onClick={handleSubmit}>{t('auth.signIn')} <i className="fas fa-sign-in-alt ms-1"></i> </button>
                                <div className="another-way-to-registration">
                                    <p>{t('auth.needAnAccount')} <Link to="#" onClick={() => setActiveForm(!activeForm)}>{t('auth.signUp')}</Link></p>
                                </div>
                            </form>
                            <form action="#" className={!activeForm ? "registration-form" : "d-none"}>
                                <div className='row mb-3'>
                                    <div className='col'>
                                        <div className="input-wrapper">
                                            <label htmlFor="name">name*</label>
                                            <input type="text" id="name" name="name" value={registrationFormData?.name || ""} onChange={handleInputChange} className='form-control' />
                                        </div>
                                    </div>
                                    {/* <div className='col'>
                                        <div className="input-wrapper">
                                            <label htmlFor="last_name">Lastname*</label>
                                            <input type="text" id="last_name" name="last_name" value={registrationFormData?.last_name || ""} onChange={handleInputChange} className='form-control' />
                                        </div>
                                    </div> */}
                                </div>
                                <div className="input-wrapper">
                                    <label htmlFor="email">{t('auth.email')}*</label>
                                    <input type="email" id="reg-email" name="email" value={registrationFormData?.email || ""} onChange={handleInputChange} className='form-control' />
                                </div>
                                <div className="input-wrapper">
                                    <label htmlFor="password">{t('auth.password')}*</label>
                                    <input type="password" id="reg-password" name="password" value={registrationFormData?.password || ""} onChange={handleInputChange} className='form-control' />
                                </div>
                                <div className="input-wrapper">
                                    <label htmlFor="confirm_password">{t('auth.confirmPassword')}*</label>
                                    <input type="password" id="confirm-password" name="confirm_password" value={registrationFormData?.confirm_password || ""} onChange={handleInputChange} className='form-control' />
                                </div>
                                <button className="btn-primary btn-titlecolor" onClick={handleSubmit}>{t('auth.signUp')}</button>
                                <div className="another-way-to-registration">
                                    <p>{t('auth.alreadyHaveAnAccount')} <Link to="#" onClick={() => setActiveForm(!activeForm)}>{t('auth.signIn')}</Link></p>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UserSignIn;